import React from 'react';

/**
 * MarkupPanel component for controlling output page markup options
 * @param {Object} props
 * @param {boolean} props.showOutputPageNumbers - Whether to show page numbers on output pages
 * @param {Function} props.setShowOutputPageNumbers - Setter for showOutputPageNumbers
 * @param {number} props.pageNumberOffset - Number of pages to skip before starting page numbers
 * @param {Function} props.setPageNumberOffset - Setter for pageNumberOffset
 * @param {number} props.pageNumberFontSize - Font size for page numbers
 * @param {Function} props.setPageNumberFontSize - Setter for pageNumberFontSize
 */
const MarkupPanel = ({
  showOutputPageNumbers,
  setShowOutputPageNumbers,
  pageNumberOffset,
  setPageNumberOffset,
  pageNumberFontSize,
  setPageNumberFontSize,
}) => {
  return (
    <div className="panel-content">
      <div className="control-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={showOutputPageNumbers}
            onChange={(e) => setShowOutputPageNumbers(e.target.checked)}
          />
          <span>Show Page Numbers</span>
        </label>
      </div>

      {showOutputPageNumbers && (
        <>
          <div className="control-group">
            <label htmlFor="pageNumberOffset">
              Page Number Offset
            </label>
            <input
              id="pageNumberOffset"
              type="number"
              min="0"
              value={pageNumberOffset}
              onChange={(e) => setPageNumberOffset(parseInt(e.target.value) || 0)}
              className="number-input"
            />
          </div>

          <div className="control-group">
            <label htmlFor="pageNumberFontSize">
              Font Size
            </label>
            <input
              id="pageNumberFontSize"
              type="range"
              min="1"
              max="8"
              value={pageNumberFontSize}
              onChange={(e) => setPageNumberFontSize(parseInt(e.target.value))}
              className="slider"
            />
          </div>
        </>
      )}
    </div>
  );
};

export default MarkupPanel;
